import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "pages/NotFound";
import LoginPage from './pages/login';
import PDFGenerationResults from './pages/pdf-generation-results';
import UserAccountDashboard from './pages/user-account-dashboard';
import PlannerSetupWizard from './pages/planner-setup-wizard';
import PlannerPreview from './pages/planner-preview';
import Register from './pages/register';
import YearOverview from './pages/year-overview';
import WeekOverview from './pages/week-overview';
import PrivacyPolicy from './pages/privacy-policy';
import ShowcaseGallery from './pages/showcase-gallery';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public routes - accessible without authentication */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/showcase" element={<ShowcaseGallery />} />
            
            {/* Protected routes - require authentication */}
            <Route path="/" element={<ProtectedRoute><PlannerSetupWizard /></ProtectedRoute>} />
            <Route path="/pdf-generation-results" element={<ProtectedRoute><PDFGenerationResults /></ProtectedRoute>} />
            <Route path="/user-account-dashboard" element={<ProtectedRoute><UserAccountDashboard /></ProtectedRoute>} />
            <Route path="/planner-setup-wizard" element={<ProtectedRoute><PlannerSetupWizard /></ProtectedRoute>} />
            <Route path="/planner-preview" element={<ProtectedRoute><PlannerPreview /></ProtectedRoute>} />
            <Route path="/year-overview" element={<ProtectedRoute><YearOverview /></ProtectedRoute>} />
            <Route path="/week-overview" element={<ProtectedRoute><WeekOverview /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;